import { Injectable } from "@angular/core";
import { DwEventService, MODAL_EVENT_CLOSE, MODAL_EVENT_OPEN } from "@devwareapps/devware-cap";

@Injectable({ providedIn: 'root' })
export class HelpScoutBeaconService {

    constructor(private dwEventService: DwEventService) {
        this.setupBeaconEvents();
      }
    
      setupBeaconEvents() {
    
        this.dwEventService.getEvent(MODAL_EVENT_OPEN).subscribe(r => {
         //console.log('Modal Opened');
          this.turnOffBeacon();
        });
    
        this.dwEventService.getEvent(MODAL_EVENT_CLOSE).subscribe(r => {
          //console.log('Modal Closed');
          this.turnOnBeacon();
        });
      }
    
      turnOnBeacon() {
        const beacon = (window as any).Beacon;
    
        if (beacon) {
          beacon('init', '8443587c-0b94-4c47-88c2-d7b17a14739f');
        }
      }
    
      turnOffBeacon() {
        const beacon = (window as any).Beacon;
    
        if (beacon) {
          beacon('close');
    
          beacon('destroy');
        }
      }
}